import { render, staticRenderFns } from "./Nachweis.vue?vue&type=template&id=7fdecc83&scoped=true&"
var script = {}
import style0 from "./Nachweis.vue?vue&type=style&index=0&id=7fdecc83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdecc83",
  null
  
)

export default component.exports